export default __webpack_public_path__ + "static/media/downArrow.fd1a57b6.svg";